// extracted by mini-css-extract-plugin
export var label = "_qz-0";
export var link = "_qz-1";